import * as React from "react";
import { Suspense } from "react";
import { Provider as ModalProvider } from "@ebay/nice-modal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { ErrorScreen } from "components/errors/components/error-screen";
import { IdentifyObservability } from "components/identify-observability";
import { LoadingScreen } from "components/loading-screen";
import { AuthProvider } from "contexts/auth-provider";
import { ThemeProvider } from "contexts/theme-provider";
import { BugsnagBoundary } from "lib/bugsnag";
import { queryClient } from "lib/react-query";
import { APIRegionListener } from "utils/api-client/api-region-listener";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <React.StrictMode>
      <FlagsmithProvider
        options={{
          environmentID: import.meta.env.VITE_FLAGSMITH_KEY,
        }}
        flagsmith={flagsmith}
      >
        <BugsnagBoundary>
          <HelmetProvider>
            <QueryClientProvider client={queryClient}>
              <ThemeProvider>
                <ModalProvider>
                  <ErrorBoundary FallbackComponent={ErrorScreen}>
                    <Suspense fallback={<LoadingScreen isFullScreen />}>
                      <AuthProvider>
                        {children}
                        <APIRegionListener />
                        <IdentifyObservability />
                      </AuthProvider>
                    </Suspense>
                  </ErrorBoundary>
                </ModalProvider>
              </ThemeProvider>
            </QueryClientProvider>
          </HelmetProvider>
        </BugsnagBoundary>
      </FlagsmithProvider>
    </React.StrictMode>
  );
}
